import { useLazyQuery } from '@apollo/client';
import bundledProductsQuery from 'api/graphql/bundledProductsQuery';
import { BundledProductItem } from 'gql/graphql';
import { useEffect, useState } from 'react';

const useAvailableSelectorsHook = (orderItemId: number, selectorName: 'abstract' | 'envelopes') => {
  const [fetch, { loading, error, data }] = useLazyQuery(bundledProductsQuery);
  const [selectedSelector, setSelectedSelector] = useState<BundledProductItem | null>(null);
  const [selectors, setSelectors] = useState<(BundledProductItem | null)[]>([]);

  const [selectorApplied, setSelectorApplied] = useState(false);

  const getSelectors = () => {
    fetch({ variables: { orderItemId } });
  };

  useEffect(() => {
    const frameData = data?.bundled_options_query?.find((item) => item?.type === selectorName);
    if (frameData && frameData?.bundledProductItems?.length) {
      // The first option is the unselect option
      setSelectors(frameData?.bundledProductItems.slice(1));
      setSelectedSelector(frameData?.bundledProductItems[1]);
    }
  }, [data]);

  return {
    getSelectors,
    selectedSelector,
    setSelectedSelector,
    selectors,
    selectorApplied,
    setSelectorApplied,
    loading,
    error,
  };
};

export default useAvailableSelectorsHook;
